export class UserProfile {
  uuid: string
  username: string
  email: string
  name?: string
  givenName?: string
  familyName?: string
  location?: {
    coordinates: [number, number]
    address?: string
  }
  avatar?: string
  isAdmin?: boolean

  getCompletionPercentage(): number {
    const fields: boolean[] = [
      this.name.length > 0,
      this.email.length > 0,
      this.location?.coordinates !== undefined,
      (this.avatar?.length || 0) > 0,
    ]
    const completedFieldCount = fields.filter(
      (completedField) => completedField
    ).length
    return (completedFieldCount / fields.length) * 100
  }
}

export class ChatUserData {
  token: string
  userId: string
}

export function getDemoUserProfile(): UserProfile {
  const userProfile = new UserProfile()
  userProfile.uuid = 'demo-profile-uuid'
  userProfile.name = 'Max Mustermann'
  userProfile.email = 'max@mustermann.de'
  userProfile.location = {
    coordinates: [51.961374141016215, 7.607869423282223],
    address: 'Hüfferstraße 27, 48149 Münster',
  }
  return userProfile
}

export class UserOAuth2Model {
  sub: string
  name: string
  // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
  preferred_username: string
  email: string
  // eslint-disable-next-line @typescript-eslint/naming-convention,no-underscore-dangle,id-blacklist,id-match
  given_name: string
  // eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
  family_name: string
}
